import React from 'react';
import styled from '@emotion/styled/macro';
import { MatrixTableRowProps } from './matrix-table.types';

const MatrixTableRow: React.FC<MatrixTableRowProps> = ({
  children,
  className,
}) => {
  if (children) {
    return (
      <tr className={className} data-testid="matrix-table-row">
        {children}
      </tr>
    );
  } else {
    console.warn(
      `MatrixTableRow received invalid arguments - children: ${children}`
    );
    return null;
  }
};

const StyledMatrixTableRow = styled(MatrixTableRow)``;

export default StyledMatrixTableRow;
